import useGetAPI from './useGetAPI';
const useFetchPerformanceData = analyticsId => {
  const {
    requestStatus,
    responseData
  } = useGetAPI('fetch-performance-data', 'activities/v2/reports/all-pages/total', {
    f: analyticsId
  });
  return {
    performanceDataRequestStatus: requestStatus,
    hasNoPerformanceData: 'total' in responseData ? responseData.total === 0 : false
  };
};
export default useFetchPerformanceData;